import { styles } from "./AnimatedStats.style";
import { useCountUpAnimation } from "./useCountUpAnimation";
import { Image } from "../../elements/Image";

export interface AnimatedStatsProps {
  tagline: string;
  stat1Value: number;
  stat1Suffix?: string;
  stat1Label: string;
  stat2Value: number;
  stat2Suffix?: string;
  stat2Label: string;
  stat3Value: number;
  stat3Suffix?: string;
  stat3Label: string;
  imageUrl?: string;
  imageAlt?: string;
}

export const AnimatedStats = (props: AnimatedStatsProps) => {
  const {
    tagline,
    stat1Value,
    stat1Suffix,
    stat1Label,
    stat2Value,
    stat2Suffix,
    stat2Label,
    stat3Value,
    stat3Suffix,
    stat3Label,
    imageUrl,
    imageAlt = "",
  } = props;
  const stats = [
    { value: stat1Value, suffix: stat1Suffix, label: stat1Label },
    { value: stat2Value, suffix: stat2Suffix, label: stat2Label },
    { value: stat3Value, suffix: stat3Suffix, label: stat3Label },
  ];

  const { containerRef, displayCounts, completed } = useCountUpAnimation([stat1Value, stat2Value, stat3Value]);

  return (
    <div ref={containerRef} className={styles.outer()}>
      <section className={styles.card()}>
        <div className={styles.taglineWrapper()}>
          <h2 className={styles.tagline()}>{tagline}</h2>
        </div>
        <ul className={styles.statList()}>
          {stats.map(({ value, suffix, label }, index) => (
            <li key={label} className={styles.statItem()}>
              <span className={styles.statValueSemantic()}>
                {value}
                {suffix} {label}
              </span>
              <span className={styles.statValue} data-completed={completed[index] || undefined} aria-hidden="true">
                {displayCounts[index]}
                {suffix}
              </span>
              <span className={styles.statLabel()} aria-hidden="true">
                {label}
              </span>
            </li>
          ))}
        </ul>
      </section>
      {imageUrl && (
        <div className={styles.imageWrapper()} aria-hidden="true">
          <Image image={{ url: imageUrl, altText: imageAlt }} />
        </div>
      )}
    </div>
  );
};
